import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NormalRightarrowLine } from '@m-ui/icons';
import { Tabs } from 'm-ui';
import { paths } from 'constants/paths';
import less from './index.module.less';
// import { useGetWebAccountInfoUsingPOST } from 'query/webAccount';

const { TabPane } = Tabs;

const InspirationOverlay: React.FC = () => {
    // const intl = useIntl();
    // const { data: userInfo } = useGetWebAccountInfoUsingPOST();

    const [activeTabKey, setActiveTabKey] = useState<string>(window.location.hash);
    const onTabChange = (key: string) => {
        setActiveTabKey(key);
    };

    return (
        <div className={less.container}>
            <Tabs
                tabPosition="left"
                // tabBarStyle={{ width: '288px' }}
                activeKey={window.location.hash === activeTabKey ? activeTabKey : ''}
                onTabClick={(key, e) => {
                    e.stopPropagation();
                    if (key === 'Others') {
                        window.location.hash = paths.HOME.path;
                    } else {
                        onTabChange(key);
                        window.location.hash = key;
                    }
                }}
            >
                <TabPane
                    tab={
                        <span className={less.titleSpan}>
                            <span>
                                <FormattedMessage defaultMessage="Top ADs" />
                            </span>
                            <NormalRightarrowLine className={less.titleSpanIcon} />
                        </span>
                    }
                    key="#/inspiration/popularads"
                />
                <TabPane
                    tab={
                        <span className={less.titleSpan}>
                            <span>
                                <FormattedMessage defaultMessage="Top Videos" />
                            </span>
                            <NormalRightarrowLine className={less.titleSpanIcon} />
                        </span>
                    }
                    key="#/inspiration/excitingvideo"
                />
                <TabPane
                    tab={
                        <span className={less.titleSpan}>
                            <span>
                                <FormattedMessage defaultMessage="Creative Strategies" />
                            </span>
                            <NormalRightarrowLine className={less.titleSpanIcon} />
                        </span>
                    }
                    key="#/inspiration/creativestrategy"
                />
            </Tabs>
        </div>
    );
};

export default InspirationOverlay;
